import { ACTION_IDS } from 'commons-ui/src/settingsV2Constant';
import type { HasPermissionArgument } from 'commons-ui/src/permission/usePermission';
import { ACTION, PAGE_NAMES, MISCELLANEOUS_RESOURCES } from '../../../../constant';

interface Params {
	hasPermission: (p: HasPermissionArgument) => boolean;
}

export const makeActionList = ({ hasPermission }: Params) => ({
	rowActions: [],
	addAction: {
		name: 'Add',
		id: ACTION_IDS.ADD,
		isEnabled: () =>
			hasPermission({
				configPageName: PAGE_NAMES.miscellaneous,
				configResourceName: MISCELLANEOUS_RESOURCES.suspiciousTransactions,
				configActionName: ACTION.createSuspiciousTransactionsRequest
			})
	}
});
